export default __webpack_public_path__ + "static/media/CustomerCase32.248c640c.png";